
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import withNavigateHook from '../../myRoutes';
import React from "react";
//import DatePicker from "react-datepicker";
import banner from '../pics/banner.PNG';
import About from '../About/About';
//import Select from 'react-select';
import { FaWhatsapp } from 'react-icons/fa';
import { ArrowLeft } from 'react-bootstrap-icons';
import { Navigate } from 'react-router-dom';
//import { getAllCustomerRegistrations, getAllActiveCustomerRegistrations, handleRealTimeUpdate } from '../Utils/Utils';
//import { LayoutDashboard} from 'lucide-react';
import axios from 'axios';
//import { redirect } from 'next/dist/server/api-utils';
class Tools extends React.Component {
    constructor(props) {
        super(props);
        this.handleAboutOpen = React.createRef();
        const today = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric" });
        const dateWithoutSecond = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: '2-digit', minute: '2-digit' });
        const dateTime = new Date().toLocaleDateString('en-uk', { hour: '2-digit', minute: '2-digit' });
        this.state = {
            date: today,
            dateWithoutSecond: dateWithoutSecond,
            dateTime: dateTime,
            userid: "",
            fullname: "",
            emailaddress: "",
            phonenumber: "",
            gender: '',
            customername: "",
            customeremail: "",
            token: "",
            role: "",
            area: "",
            city: "",
            address: "",
            modifiedby: "",
            campaignoption: "",
            language: "",
            referenceid: "",
            customerphone: ""
        }
    }
    customStyles = {
        control: (provided) => ({
            ...provided,
            height: '50px',
            borderBottom: "2px solid darkblue"
        })
    }
    
    componentDidMount = async () => {
        if (localStorage.getItem("token") === null || localStorage.getItem("token") === undefined || localStorage.getItem("token") === "") {
            this.setState({ shouldRedirect: true });
        }
        else {
            if (this.props.location.state.role !== "Admin") {

                this.props.navigate('/', {});
            }

            this.setState({
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress, modifiedby: this.props.location.state.fullname,
                phonenumber: this.props.location.state.phonenumber, gender: this.props.location.state.gender, role: this.props.location.state.role,
                userid: this.props.location.state.userid, area: this.props.location.state.area, city: this.props.location.state.city, address: this.props.location.state.address,
                referenceid: this.getReferenceId()
            })
        }
    }

    openAbout = () => {
        this.setState({ about: "about" });
        this.handleAboutOpen.current.handleAboutOpen();
    }

    goBackToMenu = (e) => {
        e.preventDefault();
        this.props.navigate('/home', {
            state: {
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress, phonenumber: this.props.location.state.phonenumber,
                gender: this.props.location.state.gender, role: this.props.location.state.role, userid: this.props.location.state.userid, area: this.props.location.state.area,
                city: this.props.location.state.city, address: this.props.location.state.address
            }
        });
    }

    setCustomerName = (e) => {
        this.setState({
            customername: this.capitalizeWords(e.target.value)
        });
    }

    todayISO = new Date().toISOString().slice(0, 10);

    setCustomerEmail = (e) => {
        this.setState({ customeremail: e.target.value });
    }

    handleShopChoice = (e) => {
        if (e.target.checked === true) {
            let str = 'Business_';
            if (this.state.language === '') {
                alert('Please select the language!');
                document.getElementById('Shop').checked = false;
                return
            }
            else {
                this.setState({ campaignoption: str + this.state.language });
                document.getElementById('Customer').checked = false;
            }
        }
    }

    handleLanguageChoice = (e, lang) => {

        if (!e.target.checked) return;
        const targetId = lang === 'en' ? 'French' : 'English';
        const targetCheckbox = document.getElementById(targetId);
        document.getElementById('Customer').checked = false;
        document.getElementById('Shop').checked = false;

        if (targetCheckbox) {
            targetCheckbox.checked = false;
        }
        this.setState({ language: lang, campaignoption: '' });

    }

    setCustomerPhoneNumber = (e) => {
        this.setState({ customerphone: e.target.value });
    }

    handleCustomerChoice = (e) => {
        if (e.target.checked === true) {
            let str = 'Customer_';
            if (this.state.language === '') {
                document.getElementById('Customer').checked = false;
                alert('Please select the language!');
                return;
            }
            else {
                this.setState({ campaignoption: str + this.state.language });
                document.getElementById('Shop').checked = false;
            }
        }
    }
    capitalizeWords(sentence) {
        return sentence
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    }

    sendCampaignMail = async () => {
        // Implement order creation logic here, such as sending data to the backend API
        let config = {
            headers: { 'Content-Type': 'application/json' },
            params: {
                customername: this.state.customername,
                customeremail: this.state.customeremail,
                modifiedby: this.props.location.state.fullname,
                campaignoption: this.state.campaignoption,
                customerphone: this.state.customerphone,
                referenceid: this.state.referenceid
            }
        };
        //  console.log(config.params)
        if (this.state.customername === "" || this.state.customeremail === "" || this.props.location.state.fullname === "" || this.state.campaignoption === '') {
            alert("Please choose an option, provide name and e-mail address before sending the action.");
            return;
        }
        else {
            // const url = "http://localhost/iwash-php/api/sendIntroMail.php";
            const url = "https://testmembership.bktsystems.com/api/UAT_setCampaign.php";
            //const url = "https://testmembership.bktsystems.com/api/sendIntroMail.php";
            const response = await axios.get(url, config);
          // console.log(response.data);
            if (response.data.includes("Success")) {
                document.getElementById("btnSubmit").style.display = "none";
                document.getElementById("successSent").style.display = "block";
                document.getElementById("errorSent").style.display = "none";
                document.getElementById('Shop').checked = false;
                document.getElementById('Customer').checked = false;
                document.getElementById('English').checked = false;
                document.getElementById('French').checked = false;
                //this.refId = this.getReferenceId();
                
                this.setState({ customername: '', customeremail: '', campaignoption: '', language: '', referenceid: this.getReferenceId() })
            }
            else {
                document.getElementById("errorSent").style.display = "block";
            }
        }
    }

    getReferenceId = () => {

        let reference = "";
        let now = new Date();
        let year = now.getFullYear().toString(); 
        year = year.slice(-2);
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const dd = String(now.getDate()).padStart(2, '0');
        const min = String(now.getMinutes()).padStart(2, '0');
        const sec = String(now.getSeconds()).padStart(2, '0');
        
        let initials = this.getFirstAndLastInitials(this.props.location.state.fullname);
        reference = `CP-${initials}${year}${month}${dd}${min}${sec}`;
        return reference;
    }

    refId = this.getReferenceId();

    getFirstAndLastInitials(name) {
        const parts = name.trim().split(/\s+/);

        if (parts.length === 0 || parts[0] === "") return "";
        if (parts.length === 1) return parts[0][0].toUpperCase();

        const firstInitial = parts[0][0];
        const lastInitial = parts[parts.length - 1][0];

        return (firstInitial + lastInitial).toUpperCase();
    }

    handleCloseToolForm = () => {
        // this.setState({ register: "", customeremail: "", customerphonenumber: "", customerfullname: "" });
        document.getElementById("btnSubmit").style.display = "none";
        this.props.navigate('/home', {
            state: {
                fullname: this.props.location.state.fullname, emailaddress: this.props.location.state.emailaddress, phonenumber: this.props.location.state.phonenumber,
                gender: this.props.location.state.gender, role: this.props.location.state.role, userid: this.props.location.state.userid, area: this.props.location.state.area,
                city: this.props.location.state.city, address: this.props.location.state.address
            }
        });
    }

    render() {
        if (this.state.shouldRedirect === true || this.props.location.state === null || this.props.location.state === undefined) {
            return <Navigate to="/" replace />;
        }

        return (
            <>
                <div style={{
                    height: "100%", margin: "0", padding: "0", paddingLeft: "10px", paddingRight: "10px", fontFamily: "lora"//backgroundColor: "#e0ded5" 

                }}>
                    <div className='mainDivHome' style={{
                        paddingTop: "5vh", border: '2px solid #f0eee4', borderRadius: "10px",
                        backgroundImage: `url(${banner})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '250px'
                    }}>
                        <div style={{
                            paddingTop: "10px", paddingBottom: "10px", textAlign: "center", color: "white", fontSize: "25px", fontWeight: "bold",
                            textShadow: "2px 2px 4px #000000"
                        }}>
                            <span style={{ fontStyle: "italic" }}><label>iWash Laundry Solutions </label></span><br />
                            <span style={{ fontStyle: "italic" }}><label>Logged in as {(this.state.fullname).split(" ")[0]} </label></span><br />
                            {/* <span style={{ fontStyle: "italic" }}><label>{this.state.date}</label></span> */}
                        </div>
                    </div>
                    <div style={{ textAlign: "center", paddingTop: "2vh" }}>
                        <span variant="primary" style={{
                            border: "none", paddingTop: "2vh", height: "60px", paddingBottom: "1vh", display: "flex", width: "100%", borderRadius: "10px",
                        }} onClick={this.goBackToMenu}>
                            <label style={{
                                textAlign: "center", fontStyle: "italic", color: "darkblue",
                                fontWeight: "bold", textShadow: "1px 1px 2px grey", fontSize: "18px"
                            }}><ArrowLeft color="darkblue" size={40} />ADMIN TOOL | Email Campaign</label>
                        </span>
                    </div>
                    <div style={{ paddingTop: "10px", fontSize: "18px", color: "darkblue" }}>
                        <fieldset style={{
                            // paddingTop: "10px",
                            paddingBottom: "5px",
                            fontSize: "16px",
                            color: "darkblue",
                            border: "none",
                            // borderTop: "1px solid darkblue",
                            margin: 0,
                            paddingLeft: 0,
                            paddingRight: 0
                        }}>
                            <legend align="left" style={{ fontSize: '16px', color: "darkblue" }}>Choose an option</legend>
                        </fieldset>
                        <div style={{ paddingBottom: "10px", fontSize: "16px", color: "darkblue", borderBottom: "1px solid darkblue" }}>
                            <div style={{ width: "100%", display: "flex" }}>
                                <div style={{ width: "50%", }}>
                                    <input style={{ marginRight: ".5rem" }}
                                        type='checkbox'
                                        name='English'
                                        id='English'
                                        onChange={(e) => this.handleLanguageChoice(e, 'en')}
                                    />
                                    English
                                </div>
                                <div style={{ width: "50%" }}>
                                    <input style={{ marginRight: ".5rem" }}
                                        type='checkbox'
                                        name='French'
                                        id='French'
                                        onChange={(e) => this.handleLanguageChoice(e, 'fr')}
                                    />
                                    Français
                                </div>
                            </div>
                            <div style={{ width: "100%", display: "flex" }}>
                                <div style={{ width: "50%", }}>
                                    <FormGroup style={{}}>
                                        <label>
                                            <input style={{ marginRight: ".5rem" }}
                                                type='checkbox'
                                                name='Customer'
                                                id='Customer'
                                                onChange={this.handleCustomerChoice}
                                            />
                                            Customer
                                        </label>
                                    </FormGroup>
                                </div>
                                <div style={{ width: "50%", }}>
                                    <FormGroup style={{}}>
                                        <label>
                                            <input style={{ marginRight: ".5rem" }}
                                                type='checkbox'
                                                name='Shop'
                                                id='Shop'
                                                onChange={this.handleShopChoice}
                                            />
                                            Laundry Admin
                                        </label>
                                    </FormGroup>
                                </div>
                            </div>
                        </div>
                        <FormGroup style={{ paddingTop: "10px" }}>
                            <Label style={{ fontStyle: "italic" }} for='customername'>Customer name</Label>
                            <Input
                                style={{ height: '50px', borderBottom: "2px solid darkblue" }}
                                type='text'
                                id='customername'
                                name='customername'
                                placeholder="Customer name"
                                value={this.state.customername}
                                onChange={this.setCustomerName}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label style={{ fontStyle: "italic" }} for="address">Customer e-mail address</Label>
                            <Input
                                style={{ height: '50px', borderBottom: "2px solid darkblue" }}
                                type="email"
                                value={this.state.customeremail}
                                onChange={this.setCustomerEmail}
                                placeholder="Customer e-mail address"
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label style={{ fontStyle: "italic" }} for="address">Customer phone number</Label>
                            <Input
                                style={{ height: '50px', borderBottom: "2px solid darkblue" }}
                                type='number'
                                id='phonenumber'
                                name='phonenumber'
                                placeholder="Customer phone number"
                                value={this.state.customerphone}
                                onChange={this.setCustomerPhoneNumber}
                                min={10}
                                max={10}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label style={{ fontStyle: "italic" }} for="address">Referencee number</Label>
                            <Input
                                style={{ height: '50px', borderBottom: "2px solid darkblue" }}
                                type='text'
                                id='refnumber'
                                name='refnumber'
                                value={this.refId}
                                readOnly={true}                            
                            />
                        </FormGroup>
                        <div id="successSent" style={{ display: "none", textAlign: "center", color: "green", fontWeight: "bold" }}>
                            <FormGroup>
                                <Label>Your Email campaign has been sent successfully! &#128591;</Label>
                            </FormGroup>
                        </div>
                        <div id="errorSent" style={{ display: "none", textAlign: "center", color: "red", fontWeight: "bold" }}>
                            <FormGroup>
                                <Label>Sorry, there was an error sending your Email campaign. Please try again &#128533;</Label>
                            </FormGroup>
                        </div>
                        <div id="btnSubmit" style={{ paddingTop: "10px" }}>
                            <Button style={{ backgroundColor: "rgba(30, 104, 40, 1)", height: "60px", width: "100%", color: 'white', fontWeight: "bold" }} onClick={this.sendCampaignMail}>Send Email</Button>
                        </div>
                        <div id="btnCloseOrderForm" style={{ paddingTop: "20px", paddingBottom: "20px" }}>
                            <Button style={{ width: "100%", fontWeight: "bold", height: "60px" }}
                                onClick={this.handleCloseToolForm} color="danger">
                                Close
                            </Button>
                        </div>
                        <div style={{
                            borderTop: "1px solid #ccc", textAlign: "center", fontSize: "14px", color: "#666", height: "100%",
                            backgroundColor: "#f0eee4", border: "solid 0px #e8cf4f", borderRadius: "10px", paddingTop: "10px", paddingBottom: "10px"
                        }}>
                            <p>&copy; {new Date().getFullYear()} HudumaSoft. All rights reserved</p>
                            <div>
                                <Button style={{
                                    backgroundColor: "transparent", border: "none", color: "blue", fontSize: "16px", cursor: "pointer",
                                    fontWeight: "bold", textDecoration: "underline"
                                }}
                                    onClick={this.openAbout}>About Us
                                </Button>
                                | <a href="https://wa.me/+27796372245" rel="noopener noreferrer" target="_blank" title="Call or WhatsApp us!"> <FaWhatsapp size={35} color="#25D366" /></a>

                            </div>
                        </div>
                        <div>
                            <About
                                ref={this.handleAboutOpen}
                                onAboutClose={this.onAboutClose}
                            />
                        </div>
                    </div>
                </div >
            </>)
    }
}
export default withNavigateHook(Tools);